import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/patientFiles',
  	  method: 'get',
        params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/patientFiles/inventory',
      method: 'get',
      params
    })
  }
  
export function show(id) {
    return request({
      url: `/patientFiles/${id}`,
      method: 'get'
    })
  }

  export function storeFile(data) {
    return request({
      url: '/patientFiles',
      method: 'post',
      data
    })
  }
  export function storeImage(data) {
    return request({
      url: '/patientFiles',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/patientFiles/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/patientFiles/${id}`,
      method: 'delete',
    })
  }
